import { GEOGRAPHY } from "../../constants/action-types";
const initialState = {
    heatMapData: [],
    stateData: [],
    metroData: [],
    metroHeatMapData: [],
    stateHeatMapData: []
}

const GeographyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GEOGRAPHY.UPDATE_HEAT_MAP_DATA: {
            return Object.assign({}, state, {
                heatMapData: action.payload
            });

        }
        case GEOGRAPHY.UPDATE_STATE_DATA: {
            return Object.assign({}, state, {
                stateData: action.payload
            });

        }
        case GEOGRAPHY.UPDATE_METRO_STATE_DATA: {
            return Object.assign({}, state, {
                metroData: action.payload
            });

        }
        case GEOGRAPHY.UPDATE_METRO_HEAT_MAP_DATA: {
            return Object.assign({}, state, {
                metroHeatMapData: action.payload
            });

        }
        case GEOGRAPHY.UPDATE_STATE_HEAT_MAP_DATA: {
            return Object.assign({}, state, {
                stateHeatMapData: action.payload
            });

        }
        default:
            return state
    }

}

export default GeographyReducer